import Carousel from 'react-bootstrap/Carousel';
import { imgResize } from './globalData';
const Slider = props => {
  const { staticel, page, is_dev } = props;
  
  const slider = [];
  for (var i = 0; i < staticel.length; i++) {
    if (staticel[i].type === 'slider' && staticel[i].id_page===page ) {
      slider.push(staticel[i].data);
    }
  }
  if (!slider.length) return null;
  return (
    <div className={"container-fluid mt-2"+(is_dev && false?' bg-danger':'')} >
      <Carousel>
    {slider.map((el, k) => (
        <Carousel.Item key={k} style={{backgroundImage: "url('"+imgResize(el.imageurl)+"')"}}>
          <Carousel.Caption className="text-end">
            <h1>{el.title}</h1>
            <p>{el.claim}</p>
      {el.text &&
            <a className="btn btn-lg btn-primary" href={el.link}>{el.text?el.text:'Mehr Infos'}</a>
      }
          </Carousel.Caption>
        </Carousel.Item>
    ))}
      </Carousel>
    </div>
  )
}

export default Slider;
